<template>
    <a-modal v-model="visible" title="成果申报详情" centered :maskClosable="false" :keyboard="false" width="75%">
        <a-spin :spinning="loading">
            <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="6">
                        <a-form-item label="成果名称" required>
                            <a-input ref="xmmc" v-model="editData.xmmc" :maxLength="100" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="专业名称" required>
                            <a-input-search ref="zymc" readOnly @search="isShow_zy = true" v-model="editData.zymc" />
                            <FGDataSelect
                                :isShow.sync="isShow_zy"
                                selectNo="JC1002"
                                :condition="'AND 1=1'"
                                @saveselect="saveEvent_zy(arguments, editData)"
                            ></FGDataSelect>
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果类型" required>
                            <FGDictSelectCN ref="cglx" dictNo="JC100601" v-model="editData.cglx" />
                        </a-form-item>
                    </a-col>
                    <!--                    <a-col :span="6">-->
                    <!--                        <a-form-item label="申报等级" required>-->
                    <!--                            <FGDictSelectCN ref="cgsbdj" dictNo="JC100602" v-model="editData.cgsbdj" />-->
                    <!--                        </a-form-item>-->
                    <!--                    </a-col>-->
                    <!--                    <a-col :span="6">-->
                    <!--                        <a-form-item label="项目密级">-->
                    <!--                            <a-input ref="xmmj" v-model="editData.xmmj" disabled />-->
                    <!--                        </a-form-item>-->
                    <!--                    </a-col>-->
                    <a-col :span="6">
                        <a-form-item label="成果开始时间" required>
                            <a-date-picker ref="cgkssj" v-model="editData.cgkssj" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果完成时间" required>
                            <a-date-picker ref="cgwcsj" v-model="editData.cgwcsj" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" required :label="'其他主要  \n完成单位'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="qtzywcdw" v-model="editData.qtzywcdw" :rows="2" :maxLength="100" placeholder="如没有其他完成单位，填写“无”" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="内容提要" required :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea
                                ref="nrty"
                                v-model="editData.nrty"
                                :rows="10"
                                :maxLength="1000"
                                placeholder="简明扼要介绍成果背景，工作过程，500字以内"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" required :label="'成果特点及  \n申报理由'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea
                                ref="cgtdjsbly"
                                :rows="10"
                                v-model="editData.cgtdjsbly"
                                :maxLength="1500"
                                placeholder="参照《关于2022年度江苏省优秀工程咨询成果水平评选的申报通知》所列的评选标准，直叙在申报成果中所做的咨询工作特点，要有利于评审专家和评委了解申报单位咨询工作的优秀之处。要求条理清晰，简明扼要，理由充分，特点突出。1500字以内。"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" required :label="'审批(核准)  \n意见摘要'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="spyjzy" v-model="editData.spyjzy" :rows="2" :maxLength="200" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item
                            class="formlabelnewline"
                            required
                            :label="'评估(评审、审查)  \n意见摘要'"
                            :label-col="{ span: 2 }"
                            :wrapper-col="{ span: 22 }"
                        >
                            <a-textarea ref="pgyjzy" :rows="2" v-model="editData.pgyjzy" :maxLength="200" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="formlabelnewline" required :label="'评价、鉴定  \n意见摘要'" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="pjjdyjzy" v-model="editData.pjjdyjzy" :maxLength="200" :rows="2" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="其他摘要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="qtzy" :rows="2" v-model="editData.qtzy" :maxLength="200" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="申报单位意见" required :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                            <a-textarea ref="sbdwyj" v-model="editData.sbdwyj" :maxLength="200" :rows="2" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <a-divider></a-divider>
            <a-tabs default-active-key="1" align="left">
                <a-tab-pane key="1" tab="成果相关附件(保存成果后上传)">
                    <vxe-table
                        ref="ZLMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataZLMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column type="seq" title="序号" width="70" align="center"> </vxe-table-column>
                        <vxe-table-column field="zlmc" title="资料名称" width="300"></vxe-table-column>
                        <vxe-table-column field="bz" title="备注" min-width="100"></vxe-table-column>
                        <vxe-table-column title="附件" width="150" align="center">
                            <template v-slot="scope">
                                <span class="btn_edit" @click="attachShow_zlmx(scope.row)">上传相关资料</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
                <a-tab-pane key="2" tab="成果获奖情况明细">
                    <vxe-toolbar size="mini">
                        <template v-slot:tools>
                            <a-button type="primary" :loading="saving || loading" @click="insertItemHJ" style="margin-right:10px">新增</a-button>
                            <!--                            <a-button type="primary" :loading="saving || loading" @click="onSaveHJ">保存</a-button>-->
                        </template>
                    </vxe-toolbar>
                    <vxe-table
                        ref="HJQKMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataHJQKMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column
                            type="seq"
                            title="序号"
                            width="70"
                            align="center"
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.xh" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="hjsj"
                            title="获奖时间"
                            width="150"
                            header-class-name="required"
                            align="center"
                        >
                            <template v-slot:edit="scope">
                                <a-date-picker ref="hjsj" v-model="scope.row.hjsj" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="jlmc"
                            title="奖励名称"
                            width="300"
                            header-class-name="required"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.jlmc" :maxLength="50" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="jldj"
                            title="等级"
                            width="120"
                            header-class-name="required"
                            align="center"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.jldj" :maxLength="10" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            field="jjse"
                            title="奖金数额(元)"
                            width="110"
                            header-align="center"
                            align="right"
                            :edit-render="{ type: 'default', autofocus: 'input' }"
                        >
                            <template v-slot:edit="scope">
                                <a-input-number size="small" v-model="scope.row.jjse" :precision="2" />
                            </template>
                            <template v-slot="{ row }">
                                <span> {{ $FG_util.formatNumber(row.jjse, "0.00") }} </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="sjbm"
                            title="授奖部门"
                            min-width="100"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.sjbm" :maxLength="100" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column title="附件" width="150" align="center">
                            <template v-slot="scope">
                                <span class="btn_edit" @click="attachShow_hjqk(scope.row)">相关材料</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column title="操作" width="70" align="center">
                            <template v-slot="scope">
                                <span class="btn_edit" @click="removeItemHJ(scope.row)">删除</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
                <a-tab-pane key="3" tab="成果主要完成人情况明细">
                    <vxe-toolbar size="mini">
                        <template v-slot:tools>
                            <a-button type="primary" :loading="saving || loading" @click="insertItemWCR" style="margin-right:10px">新增</a-button>
                            <!--                            <a-button type="primary" :loading="saving || loading" @click="onSaveWCR">保存</a-button>-->
                        </template>
                    </vxe-toolbar>
                    <vxe-table
                        ref="WCRMXitemTable"
                        size="mini"
                        resizable
                        keep-source
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="editItemDataWCRMX"
                        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                    >
                        <vxe-table-column
                            type="seq"
                            title="序号"
                            width="70"
                            align="center"
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.xh" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="xm"
                            title="姓名"
                            width="120"
                            header-class-name="required"
                            align="center"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.xm" :maxLength="20" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="xb"
                            title="性别"
                            width="100"
                            align="center"
                            ><template v-slot:edit="scope"> <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="scope.row.xb" /> </template
                        ></vxe-table-column>
                        <vxe-table-column field="nl" title="年龄" width="100" align="center" :edit-render="{ type: 'default', autofocus: 'input' }">
                            <template v-slot:edit="scope">
                                <a-input-number size="small" v-model="scope.row.nl" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="zc"
                            title="职称"
                            width="200"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.zc" :maxLength="20" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            :edit-render="{
                                type: 'default',
                                autofocus: 'input'
                            }"
                            field="gzdw"
                            title="工作单位"
                            min-width="100"
                            header-class-name="required"
                        >
                            <template v-slot:edit="scope">
                                <a-input size="small" v-model="scope.row.gzdw" :maxLength="100" />
                            </template>
                        </vxe-table-column>
                        <vxe-table-column title="操作" width="70" align="center">
                            <template v-slot="scope">
                                <span class="btn_edit" @click="removeItemWCR(scope.row)">删除</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
            </a-tabs>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                关闭
            </a-button>
            <a-button :loading="loading || saving" type="primary" @click="onSave" style="margin-right:8px;">
                保存
            </a-button>
        </template>
        <AttachModalUpload :attachCfg.sync="attachProps_zlmx" />
        <AttachModalUpload :attachCfg.sync="attachProps_hjqk" />
    </a-modal>
</template>

<script>
export default {
    name: "CgsbcxmxEdit",
    props: ["showCgsbcxmxEdit", "dataId", "cgsbbmxid"],
    data() {
        return {
            // 避免重复点击提交
            dateFormat: "YYYY-MM-DD",
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataZLMX: [],
            editItemDataZLMXLoading: false,
            editItemDataHJQKMX: [],
            editItemDataHJQKMXLoading: false,
            editItemDataWCRMX: [],
            editItemDataWCRMXLoading: false,
            isShow_zy: false,
            attachProps_zlmx: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_ZLMX",
                fkfield: "ID",
                attachSource: "CG1001"
            },
            attachProps_hjqk: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_HJQK",
                fkfield: "ID",
                attachSource: "CG1001"
            }
        };
    },
    computed: {
        // 是否显示编辑界面
        visible: {
            get() {
                return this.showCgsbcxmxEdit;
            },
            set(newVal) {
                this.$emit("update:showCgsbcxmxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    if (this.cgsbbmxid) {
                        this.loadData(this.cgsbbmxid);
                    } else {
                        let xh = this.$parent.editItemDataCGSBB.length + 1;
                        this.editData = {
                            isnew: true,
                            id: this.$FG_util.uuid(),
                            cgsbbid: this.dataId,
                            xh: xh,
                            xmztz: 0,
                            tjbj: 0,
                            mxzt: "专家未选定"
                        };
                        this.editItemDataZLMX = [];
                        this.editItemDataHJQKMX = [];
                        this.editItemDataWCRMX = [];
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        loadData(cgsbbmxid) {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/selectSbxmmxById",
                    {
                        id: cgsbbmxid
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 加载资料明细数据
                            this.loadItemDataZLMX();
                            // 加载获奖情况明细数据
                            this.loadItemDataHJQKMX();
                            // 加载完成人明细数据
                            this.loadItemDataWCRMX();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.visible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.visible = false;
                    }
                });
        },
        loadItemDataZLMX() {
            this.editItemDataZLMX = [];
            this.editItemDataZLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemZlmx",
                    {
                        cgsbbmxid: this.editData.id,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataZLMXLoading = false;
                    if (success) {
                        this.editItemDataZLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        loadItemDataHJQKMX() {
            this.editItemDataHJQKMX = [];
            this.editItemDataHJQKMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemHjqkmx",
                    {
                        cgsbbmxid: this.editData.id,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataHJQKMXLoading = false;
                    if (success) {
                        this.editItemDataHJQKMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        loadItemDataWCRMX() {
            this.editItemDataWCRMX = [];
            this.editItemDataWCRMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemWcrqkmx",
                    {
                        cgsbbmxid: this.editData.id,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataWCRMXLoading = false;
                    if (success) {
                        this.editItemDataWCRMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onClose();
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        onSave() {
            if (!this.editData.xmmc) {
                this.$FG_message.error("P0001", "成果名称").then(() => this.$refs.xmmc.focus());
                return;
            }
            if (!this.editData.zymc) {
                this.$FG_message.error("P0001", "专业名称").then(() => this.$refs.zymc.focus());
                return;
            }
            if (!this.editData.cglx) {
                this.$FG_message.error("P0001", "成果类型").then(() => this.$refs.cglx.focus());
                return;
            }
            if (!this.editData.qtzywcdw) {
                this.$FG_message.error("P0001", "其他主要完成单位").then(() => this.$refs.qtzywcdw.focus());
                return;
            }
            // if (!this.editData.cgsbdj) {
            //     this.$FG_message.error("P0001", "申报等级").then(() => this.$refs.cgsbdj.focus());
            //     return;
            // }
            if (!this.editData.cgkssj) {
                this.$FG_message.error("P0001", "成果开始时间").then(() => this.$refs.cgkssj.focus());
                return;
            }
            if (!this.editData.cgwcsj) {
                this.$FG_message.error("P0001", "成果完成时间").then(() => this.$refs.cgwcsj.focus());
                return;
            }
            if (!this.editData.nrty) {
                this.$FG_message.error("P0001", "内容提要").then(() => this.$refs.nrty.focus());
                return;
            }
            if (!this.editData.cgtdjsbly) {
                this.$FG_message.error("P0001", "成果特点及申报理由").then(() => this.$refs.cgtdjsbly.focus());
                return;
            }
            if (!this.editData.spyjzy) {
                this.$FG_message.error("P0001", "审批（核准）意见摘要").then(() => this.$refs.spyjzy.focus());
                return;
            }
            if (!this.editData.pgyjzy) {
                this.$FG_message.error("P0001", "评估（评审、审查）意见摘要").then(() => this.$refs.pgyjzy.focus());
                return;
            }
            if (!this.editData.pjjdyjzy) {
                this.$FG_message.error("P0001", "评价、鉴定意见摘要").then(() => this.$refs.pjjdyjzy.focus());
                return;
            }
            // if (!this.editData.qtzy) {
            //     this.$FG_message.error("P0001", "其他摘要").then(() => this.$refs.qtzy.focus());
            //     return;
            // }
            if (!this.editData.sbdwyj) {
                this.$FG_message.error("P0001", "申报单位意见").then(() => this.$refs.sbdwyj.focus());
                return;
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/saveCGPXSBB",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        //this.cgsbbmxid = this.editData.id;
                        this.editData.isnew = false;
                        this.onSaveHJ();
                        this.onSaveWCR();
                        this.loadData(this.editData.id);
                        this.$emit("dataUpdated", this.dataId);
                        //this.visible = false;
                    } else {
                        this.$refs.xmmc.focus();
                    }
                });
        },
        // 附件管理
        attachShow_zlmx(row) {
            // 设置编辑记录id
            this.attachProps_zlmx.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_zlmx.visible = true;
        },
        // 附件管理
        attachShow_hjqk(row) {
            // 设置编辑记录id
            this.attachProps_hjqk.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_hjqk.visible = true;
        },
        saveEvent_zy(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.zyid = val[0][0].ID;
                this.editData.zymc = val[0][0].ZYMC;
            }
        },
        // 新增获奖情况
        insertItemHJ() {
            // 设置编辑记录
            let xh = this.$refs.HJQKMXitemTable.getTableData().tableData.length + 1;
            this.$refs.HJQKMXitemTable.insertAt(
                {
                    isnew: true,
                    id: this.$FG_util.uuid(),
                    cgsbbid: this.dataId,
                    cgsbbmxid: this.editData.id,
                    xh: xh
                },
                -1
            ).then(({ row }) => {
                this.$refs.HJQKMXitemTable.setActiveRow(row);
            });
        },
        // 新增完成人
        insertItemWCR() {
            // 设置编辑记录
            let xh = this.$refs.WCRMXitemTable.getTableData().tableData.length + 1;
            this.$refs.WCRMXitemTable.insertAt(
                {
                    isnew: true,
                    id: this.$FG_util.uuid(),
                    cgsbbid: this.dataId,
                    cgsbbmxid: this.editData.id,
                    xh: xh
                },
                -1
            ).then(({ row }) => {
                this.$refs.WCRMXitemTable.setActiveRow(row);
            });
        },
        // 删除完成人明细
        removeItemWCR(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.WCRMXitemTable.remove(row);
                    } else {
                        this.editDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zxcggl/cgsbgl/deleteWcrqkmx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editDataLoading = false;
                                if (success) {
                                    this.loadItemDataWCRMX();
                                }
                            });
                    }
                }
            });
        },
        // 删除获奖情况明细
        removeItemHJ(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.HJQKMXitemTable.remove(row);
                    } else {
                        this.editDataLoading = true;
                        this.$FG_http
                            .post("./api/main/zxcggl/cgsbgl/deleteHjqkmx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editDataLoading = false;
                                if (success) {
                                    this.loadItemDataHJQKMX();
                                }
                            });
                    }
                }
            });
        },
        //保存
        onSaveHJ() {
            let itemData = [];
            if (this.$refs.HJQKMXitemTable) {
                itemData = this.$refs.HJQKMXitemTable.getInsertRecords().concat(this.$refs.HJQKMXitemTable.getUpdateRecords());
            }
            for (let i = 0; i < itemData.length; i++) {
                if (!itemData[i].hjsj) {
                    this.$FG_message.error("P0001", "获奖时间").then(() => {
                        this.$refs.HJQKMXitemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
                if (!itemData[i].jlmc) {
                    this.$FG_message.error("P0001", "奖励名称").then(() => {
                        this.$refs.HJQKMXitemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
                if (!itemData[i].jldj) {
                    this.$FG_message.error("P0001", "等级").then(() => {
                        this.$refs.HJQKMXitemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
            }
            // 保存操作
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/saveHJQKMX",
                    {
                        itemData
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        //this.loadItemDataHJQKMX();
                    } else {
                        this.$refs.jlmc.focus();
                    }
                });
        },
        //保存
        onSaveWCR() {
            let itemData = [];
            if (this.$refs.HJQKMXitemTable) {
                itemData = this.$refs.WCRMXitemTable.getInsertRecords().concat(this.$refs.WCRMXitemTable.getUpdateRecords());
            }
            for (let i = 0; i < itemData.length; i++) {
                if (!itemData[i].xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => {
                        this.$refs.WCRMXitemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
                if (!itemData[i].gzdw) {
                    this.$FG_message.error("P0001", "工作单位").then(() => {
                        this.$refs.WCRMXitemTable.setActiveRow(itemData[i]);
                    });
                    return;
                }
            }
            // 保存操作
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/saveWCRQKMX",
                    {
                        itemData
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        //this.loadItemDataWCRMX();
                    } else {
                        this.$refs.xm.focus();
                    }
                });
        }
    }
};
</script>
<style lang="scss" scoped></style>
